// extracted by css-extract-rspack-plugin
export default {"toast":"toast_toast__1j_ZY","text":"toast_text__lEPWa"};